import Alert from './Alert';
import axios from 'axios';
import _ from 'lodash';
import { benefitTypes } from '../constants/transfers/benefits/types';
import { productsName } from '../constants/products/products';
import { allTypes } from '../constants/transfers/types/types';
import { dateFns, exportCsvFileNameDates } from '../helpers';
import numeral from 'numeral';

import statuses from '../constants/transfers/statuses';

const formatDay = 'dd/MM/yyyy';
const formatHour = 'HH:mm';

// version 1 with data from core, suppliers
export const downloadAs = (data, name) => {
    try {
        const blob = new Blob([data], { type: 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8,' });
        const blobURL = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobURL;
        a.style = 'display: none';

        if (name && name.length) {
            a.download = name;
        }

        document.body.appendChild(a);
        a.click();

        setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            URL.revokeObjectURL(blobURL);
        }, 100);
    }
    catch (error) {
        console.error(error);
    }
};

// version 2
export const downloadCSV = (csv, filename) => {
    var csvFile;
    var downloadLink;

    // CSV file
    csvFile = new Blob([csv], { type: 'text/csv' });

    // Download link
    downloadLink = document.createElement('a');

    // File name
    downloadLink.download = filename;

    // Create a link to the file
    downloadLink.href = window.URL.createObjectURL(csvFile);

    // Hide download link
    downloadLink.style.display = 'none';

    // Add the link to DOM
    document.body.appendChild(downloadLink);

    // Click download link
    downloadLink.click();
};

function exportTableToCSV (filename) {
    const csv = [];
    const rows = document.querySelectorAll('table tr');

    for (let i = 0; i < rows.length; i++) {
        const row = [];
        const cols = rows[i].querySelectorAll('td, th');

        for (var j = 0; j < cols.length; j++) {
            const cellValue = cols[j].innerText.replace('\n', ' ').replace('AR$', '').replace('USD$', '');

            row.push(`"${cellValue}"`);
        }

        csv.push(row.join(';'));
    }
    // Download CSV file
    downloadCSV(csv.join('\n'), filename);
}

export const downloadReport = (pageUIContext) => {
    pageUIContext.setIsLoading(true);

    // Prepare body for Report name
    const body = {
        nameTable: window.location.pathname.slice(1, window.location.pathname.length),
        startAt: pageUIContext.queryParams?.filters?.filters?.created_at?.be[0] || '',
        endAt: pageUIContext.queryParams?.filters?.filters?.created_at?.be[1] || ''// toLocaleDateString()
    };

    const { formattedStartAt, formattedEndAt } = exportCsvFileNameDates(body.startAt, body.endAt);

    const fileName = body.startAt ? `Reporte del ${formattedStartAt} al ${formattedEndAt} ${body.nameTable}.csv` : `Reporte ${body.nameTable}.csv`;

    // version 1
    try {
        exportTableToCSV(fileName);
        pageUIContext.setIsLoading(false);
    }
    catch (error) {
        Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
        console.error('Error on download', error);
        pageUIContext.setIsLoading(false);
    }
};

// Funcion para asientos contables
function exportTableToCSVForAC (filename) {
    const csv = [];
    const rows = document.querySelectorAll('table tr');
    for (let i = 0; i < rows.length; i++) {
        const row = [];
        const cols = rows[i].querySelectorAll('td, th');
        for (var j = 0; j < cols.length; j++) {
            row.push(cols[j].innerText.replace('\n', ' ').replace('AR$', '').replace('USD$', '').replace('.', '').replace(',', '.'));
        }
        csv.push(row.join(';'));
    }
    const firstRow = 'Campo obligatorio                                               Formato                dd-mm-aaaa;Campo obligatorio          Numérico              ;Campo obligatorio                            Código de Cuenta ;Campo obligatorio                                           Detalle Asiento;Campo Opcional                       Descripción del Valor del Centro de costo 1;Campo Opcional                       Descripción del Valor del Centro de costo 2;Campo Opcional                       Nombre del Proveedor o Cliente tal como fue creado en Colppy;Campo obligatorio (salvo que se complete Haber $)       Numérico                                                                    ;Campo obligatorio (salvo que se complete Debe $)       Numérico                                                                    ;';
    csv.unshift(firstRow);
    const voidColumnOne = 'Centro de Costo 1';
    const voidColumnTwo = 'Centro de Costo 2';
    const voidColumnThree = 'Tercero';
    // Pushing void columns in the array only with title like Colppy's format requires
    const separatedData = csv[1].split(';');
    const dataAfterVoid = separatedData.splice(4);
    separatedData.push(voidColumnOne, voidColumnTwo, voidColumnThree);
    const totalData = separatedData.concat(dataAfterVoid);
    csv[1] = totalData.join(';');

    // Pushing blank spaces into the void columns that were pushed before to respect Colppy's format
    for (let i = 0; i < csv.length; i++) {
        if (i > 1) {
            const separatedData = csv[i].split(';');
            const dataAfterVoid = separatedData.splice(4);
            dataAfterVoid.unshift('', '', '');
            const totalData = separatedData.concat(dataAfterVoid);
            const final = totalData.join(';');
            csv[i] = final;
        }
    }
    // Download CSV file
    downloadCSV(csv.join('\n'), filename);
}

// Funcion para asientos contables
export const downloadReportForAC = (pageUIContext) => {
    pageUIContext.setIsLoading(true);

    // Prepare body for Report name
    const body = {
        nameTable: window.location.pathname.slice(1, window.location.pathname.length),
        startAt: pageUIContext.queryParams?.filters?.filters?.startAt?.eq || ''
    };

    const fileName = body.startAt ? `Reporte del ${body.startAt}.csv` : `Reporte ${body.nameTable}.csv`;

    // version 1
    try {
        exportTableToCSVForAC(fileName);
        pageUIContext.setIsLoading(false);
    }
    catch (error) {
        Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
        console.error('Error on download', error);
        pageUIContext.setIsLoading(false);
    }
};

// NEW MODE OF EXPORT CSV FILE
export const downloadListCSV = (pageUIContext, list, mode, page, setOpenDownloadModal, filters) => {
    pageUIContext.setIsLoading(true);

    // Prepare body for Report name
    const body = {
        nameTable: window.location.pathname.slice(1, window.location.pathname.length),
        startAt: pageUIContext.queryParams?.filters?.filters?.created_at?.be[0] || '',
        endAt: pageUIContext.queryParams?.filters?.filters?.created_at?.be[1] || ''// toLocaleDateString()
    };

    const { formattedStartAt, formattedEndAt } = exportCsvFileNameDates(body.startAt, body.endAt);

    const fileName = body.startAt ? `Reporte del ${formattedStartAt} al ${formattedEndAt} ${body.nameTable}.csv` : `Reporte ${body.nameTable}.csv`;

    try {
        if (mode === 'clients') {
            exportTableClientsCSV(fileName, list, page, setOpenDownloadModal);
            pageUIContext.setIsLoading(false);
        }
        else if (mode === 'accounts') {
            exportTableAccountsCSV(fileName, list, page, setOpenDownloadModal);
            pageUIContext.setIsLoading(false);
        }
        else if (mode === 'transfers') {
            exportTableToTransferCSV(fileName, list, page, setOpenDownloadModal, filters);
            pageUIContext.setIsLoading(false);
        };
    }
    catch (error) {
        Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
        console.error('Error on download', error);
        pageUIContext.setIsLoading(false);
    };
};

// EXPORT CVS FILE TO TRANSFER
const csvTransfer = [];
function exportTableToTransferCSV (filename, list, page, setOpenDownloadModal, filters) {
    const rows = document.querySelector('table tr');
    const header = rows.innerText.split('\t');
    if (page === 1) {
        csvTransfer.push(header.join(';'));
    }
    let index = 0;
    list.map(item => {
        const userOriginId = item.userOrigin?.id ? item.userOrigin.id : item.id_account_origin;
        const numberOrigin = _.padStart(userOriginId, 9, '0');
        const numberDestiny = _.padStart(userOriginId, 9, '0');
        const date = new Date(item.created_at);
        const amount = `${numeral(item.amount).format(numeral.defaultDecimalFormat)}`;
        let title = '';
        let subtitle = '';
        const origin = `${numberOrigin.substring(0, 2)}-${numberOrigin.substring(2, 8)}-${numberOrigin.substring(8)}`;
        const destination = `${numberDestiny.substring(0, 2)}-${numberDestiny.substring(2, 8)}-${numberDestiny.substring(8)}`;
        if (item.accounts.origin?.id === 46) {
            const operation = benefitTypes[item?.benefit?.benefit?.id];
            const fullName = item?.userBenefited?.formattedName;
            title = operation || 'S/D';
            subtitle = `${fullName}`;
        }
        else {
            title = `${item.description.includes('IVA Comisión') ? item.description : (allTypes[item.type.description] || item.type.description)}`;
            subtitle = `${item.description}`;
        }
        const row = [item.id, dateFns.format(date, formatDay), dateFns.format(date, formatHour), `${title} ${subtitle}`, amount, item.userOrigin?.formattedName, item.userOrigin?.cuit, origin, item.userDestination?.formattedName, destination, statuses[item.status.description].text];
        csvTransfer.push(row.join(';'));
        index++;

        return item;
    });
    // Download CSV file
    if ((filters && index < 100) || page === 100) {
        downloadCSV(csvTransfer.join('\n'), filename);
        setTimeout(() => {
            setOpenDownloadModal(false);
        }, 1500);
    }
}

// EXPORT CSV FILE TO CLIENTS
const csvClient = [];
function exportTableClientsCSV (filename, list, page, setOpenDownloadModal) {
    const rows = document.querySelector('table tr');
    const header = rows.innerText.split('\t');
    if (page === 1) {
        csvClient.push(header.join(';'));
    }
    list.map(item => {
        const date = new Date(item.created_at);
        const amount = `${numeral(item.mainAccount.wallet.amount).format(numeral.defaultDecimalFormat)}`;
        const row = [item.id, item.formattedName, item.person?.document?.type?.description.toUpperCase(), item.person?.document?.description, item.person?.telephone ? item.person?.telephone?.description : '-', amount, dateFns.format(date, formatDay), statuses[item.status.description].text, ''];
        csvClient.push(row.join(';'));
        return item;
    });
    if (page === 100) {
        downloadCSV(csvClient.join('\n'), filename);
        setOpenDownloadModal(false);
    }
}

// EXPORT CSV FILE TO ACCOUNTS
const csvAccount = [];
function exportTableAccountsCSV (filename, list, page, setOpenDownloadModal) {
    const rows = document.querySelector('table tr');
    const header = rows.innerText.split('\t');
    if (page === 1) {
        csvAccount.push(header.join(';'));
    }
    list.map(item => {
        const title = productsName[item.product.attributes.description.value] || (item.product.attributes.description.value || 'S/D');
        const subtitle = item.attributes?.description?.value || 'S/D';
        const numberId = _.padStart(item.id, 9, '0');
        const id = `${numberId.substring(0, 2)}-${numberId.substring(2, 8)}-${numberId.substring(8)}`;
        const date = new Date(item.created_at);
        const status = item.active === 1 ? 'Activa' : 'Inactiva';
        const amount = `${numeral(item.wallet.amount).format(numeral.defaultDecimalFormat)}`;
        const row = [id, item.user.formattedName, `${title} ${subtitle}`, amount, dateFns.format(date, formatDay), status];
        csvAccount.push(row.join(';'));
        return item;
    });
    if (page === 100) {
        downloadCSV(csvAccount.join('\n'), filename);
        setOpenDownloadModal(false);
    }
}

// Downloads a file the API exposes as a URL. Errors are left to propagate so
// the caller can show them: the tables that use this render an alert when a
// download fails, which is not possible if the failure is swallowed here.
export const downloadFileFromUrl = async (url, fileName) => {
    const { data } = await axios.get(url, { responseType: 'arraybuffer' });
    downloadCSV(data, fileName);
};

// Downloader from URL of s3

export const downloadFromUrl = (url) => {
    const element = document.createElement('a');
    element.href = url;
    element.className = 'd-none';
    // Required for this to work in FireFox
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
};

// Downloader from url with filename
export const downloadWithNameFromUrl = (link, fileName) => {
    fetch(link)
        .then(response => response.blob())
        .then(blob => {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        })
        .catch(error => {
            console.error('Error al descargar el archivo:', error);
        });
};
